<template>
    <div id="transforms">
        <div :class="idx == item.id?'btn se':'btn'" v-for="item in controls" :key="item.id" @click.stop="transform(item)">{{item.operation}}</div>
    </div>
</template>

<script>
export default {
    props:["tileset"],
    data(){
        return {
            controls:[
                {
                    id:1,
                    operation:'向左平移',
                },
                {
                    id:2,
                    operation:'向右平移',
                },
                {
                    id:3,
                    operation:'向上平移',
                },
                {
                    id:4,
                    operation:'向下平移',
                },
                {
                    id:5,
                    operation:'向前平移',
                },
                {
                    id:6,
                    operation:'向后平移',
                },
                // {
                //     id:7,
                //     operation:'x轴旋转',
                // },
                // {
                //     id:8,
                //     operation:'y轴旋转',
                // },
                // {
                //     id:9,
                //     operation:'z轴旋转',
                // },
                // {
                //     id:10,
                //     operation:'放大',
                // },
            ],
            viewModel:{
                x: 0,
                y: 0,
                z: 0,
                RotateX:0,
                RotateY:0,
                RotateZ:0,
                scale:10
            },
            idx:0
        }
    },
    mounted(){
        console.log(this.tileset);
        if(this.tileset){
            this.knockoutTile(this.tileset)
        }
    },
    methods:{
        knockoutTile(tileset){
            let _this = this
            Cesium.knockout.track(this.viewModel)
            let ele = document.getElementById('transforms')
            Cesium.knockout.applyBindings(this.viewModel, ele)

            Cesium.knockout.getObservable(this.viewModel, 'x').subscribe((x)=>{
                let matrix = tileset.modelMatrix
                let end_matrix = _this.translation({x,matrix})
                tileset.modelMatrix = end_matrix
            })

            Cesium.knockout.getObservable(this.viewModel, 'y').subscribe((y)=>{
                let matrix = tileset.modelMatrix
                let end_matrix = _this.translation({y,matrix})
                tileset.modelMatrix = end_matrix
            })

            Cesium.knockout.getObservable(this.viewModel, 'z').subscribe((z)=>{
                let matrix = tileset.modelMatrix
                let end_matrix = _this.translation({z,matrix})
                tileset.modelMatrix = end_matrix
            })

            Cesium.knockout.getObservable(this.viewModel, 'RotateX').subscribe((rx)=>{
                let matrix = tileset._root.transform
                let end_matrix = _this.rotation({rx, matrix})
                tileset._root.transform = end_matrix
            })

            Cesium.knockout.getObservable(this.viewModel, 'RotateY').subscribe((ry)=>{
                let matrix = tileset._root.transform
                let end_matrix = _this.rotation({ry, matrix})
                tileset._root.transform = end_matrix
            })

            Cesium.knockout.getObservable(this.viewModel, 'RotateZ').subscribe((rz)=>{
                let matrix = tileset._root.transform
                let end_matrix = _this.rotation({rz, matrix})
                tileset._root.transform = end_matrix
                viewer.zoomTo(tileset)
            })


        },
        scale(params){
            let {
                scale = 1,
                matrix
            } = params
            console.log(scale);
            let scaleM = Cesium.Matrix4.fromUniformScale(scale);
            matrix =  Cesium.Matrix4.multiply(matrix, scaleM, matrix)

            return matrix
        },
        rotation(rotation){
            let {
                rx = 0,
                ry = 0,
                rz = 0,
                matrix
            } = rotation 
            let _rotateX = Cesium.Matrix3.fromRotationX(Cesium.Math.toRadians(rx));
            let _rotateY = Cesium.Matrix3.fromRotationY(Cesium.Math.toRadians(ry));
            let _rotateZ = Cesium.Matrix3.fromRotationZ(Cesium.Math.toRadians(rz));
            matrix = Cesium.Matrix4.multiplyByMatrix3(matrix, _rotateX, matrix);
            matrix = Cesium.Matrix4.multiplyByMatrix3(matrix, _rotateY, matrix);
            matrix = Cesium.Matrix4.multiplyByMatrix3(matrix, _rotateZ, matrix);   

            return matrix;
        },
        translation(translation){
            let {
                x = 0,
                y = 0,
                z = 0,
                matrix
            } = translation

            // 创建一个平移向量
            let transform = new Cesium.Cartesian3(x, y, z)
            // 构造平移矩阵
            let matrix1 = Cesium.Matrix4.fromTranslation(transform)
            // 算出结果矩阵
            let end_matrix = Cesium.Matrix4.multiply(matrix, matrix1, matrix)
            return end_matrix
        },
        transform(control){
            this.idx = control.id
            let _this = this
            switch(control.id){
                case 1:
                    _this.viewModel.x -= 10
                    break;
                case 2:
                    _this.viewModel.x += 10
                    break;
                case 3:
                    _this.viewModel.y += 10
                    break;
                case 4:
                    _this.viewModel.y -= 10
                    break;
                case 5:
                    _this.viewModel.z -= 10
                    break;
                case 6:
                    _this.viewModel.z += 10
                    break;
                case 7:
                    _this.viewModel.RotateX += 0.5
                    break;
                case 8:
                    _this.viewModel.RotateY += 0.5
                    break;
                case 9:
                    _this.viewModel.RotateZ += 0.5
                    break;
                case 10:
                    _this.viewModel.scale += 1
                    break;
            }
        }
    }
}
</script>

<style lang="less" scoped>
    #transforms{
        position: fixed;
        left: 1vw;
        top: 5vh;
        width: 5vw;
        height: 45vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .btn{
            width: 100%;
            text-align: center;
            background: #fff;
            border-radius: 5px;
            color: #000;
            font-weight: bold;
        }
        .se{
            background: #ffffff2b;
            color: #fff;
        }
    }

</style>